RivalIQ.module('models', function (models, App, Backbone, Marionette, $, _, CompareData) {

    'use strict';

    models.SocialHandle = Backbone.Model.extend({
        initialize: function () {
            const me = this;

            me.listenTo(me, 'change:handle', me.setProfileUrl);
            me.listenTo(me, 'change:native_id', me.setProfileUrl);

            me.setProfileUrl();
        },

        urlRoot: function () {
            const me = this;
            return `/api/channels/${me.getSourceDetails().channel}/handles`;
        },

        parse: function (resp, options) {
            const me = this;

            const additionalFields = {
                source: me.get('source'),
                finderPicked: options.finderPicked
            };

            return _.extend(resp, additionalFields);
        },

        setProfileUrl: function () {
            const me = this;

            const identityType = me.getSourceDetails().identityType;
            const baseUrl = me.getSourceDetails().profileUrl;
            me.set({
                profileUrl: baseUrl + me.get(identityType)
            });
        },

        getSourceDetails: function () {
            const me = this;

            return CompareData.sourceDetails[me.get('source')];
        }
    });

    models.SocialHandle.build = function (presence) {
        const map = {};
        map[CompareData.sources.INSTAGRAM] = 'handle';
        const key = map[presence.get('source')] || 'native_id';

        return new RivalIQ.models.SocialHandle({
            id: presence.get(key),
            source: presence.get('source')
        });
    };

}, RivalIQ.data.CompareData);
